import { render } from "./CModal.vue?vue&type=template&id=cdcb4aae"
import script from "./CModal.vue?vue&type=script&lang=js"
export * from "./CModal.vue?vue&type=script&lang=js"

import "./CModal.vue?vue&type=style&index=0&id=cdcb4aae&lang=css"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__